import {useSelector} from 'react-redux';
import {Attributes} from 'src/types/contentTypes';

export default function useSite(): Attributes['tenant'] {
	// @ts-ignore
	let site = useSelector((state) => state.admin.user.OwnedWebsite);
	return site;
}
